export default __webpack_public_path__ + "static/media/001-badge.866efba4.svg";